import clsx from "clsx"
import React from "react"

const Close = ({fill, className, onClick}) => {
    return (
        <svg onClick={onClick} className={clsx(className, 'h-6')} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path className={clsx(fill || 'fill-black')} d="M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"/></svg>
    )
}

export default Close